import { Component, inject } from '@angular/core'
import { Dialog, DialogRef } from '@angular/cdk/dialog'
import { Router } from '@angular/router'

import { Icon } from '@shared/ui'
import { getModalComponent } from '../../data/notification-modals'
import { NotificationsStore } from '../../data/notifications-store'
import { Notification } from '../../models/notification.model'
import { NotificationItem } from '../notification-item/notification-item'
import { NotificationItemSkeleton } from '../notification-item/notification-item-skeleton'
import { NotificationModal } from '../notification-modal/notification-modal'

/** Panel lateral con el listado. Lo abre el header a través del CDK. */
@Component({
  selector: 'notifications-panel',
  imports: [Icon, NotificationItem, NotificationItemSkeleton],
  host: { class: 'bg-grad-blue-deep flex h-dvh w-full flex-col' },
  templateUrl: './notifications-panel.html'
})
export class NotificationsPanel {
  readonly #dialog = inject(Dialog)
  readonly #router = inject(Router)

  protected readonly store = inject(NotificationsStore)
  protected readonly dialogRef = inject(DialogRef)

  /** Al abrir el panel se refresca, por si llegaron avisos nuevos. */
  constructor() {
    void this.store.load()
  }

  /**
   * Marca leída y actúa según el aviso: abre su modal propio, el genérico si
   * trae `modalBody`, o lleva al link. En todos los casos cierra el panel.
   */
  protected async select(notification: Notification): Promise<void> {
    void this.store.markAsRead(notification.id)

    const specific = await getModalComponent(notification.id)

    if (specific || notification.modalBody) {
      this.dialogRef.close()
      this.#dialog.open(specific ?? NotificationModal, { data: notification, panelClass: 'modal-frame' })
      return
    }

    const link = notification.link
    if (!link) return

    this.dialogRef.close()

    if (link.startsWith('/')) void this.#router.navigateByUrl(link)
    else window.open(link, '_blank', 'noopener')
  }
}
